export default __webpack_public_path__ + "static/Alerts_Mobile-f5919f531eeabbfa58684a188ac38004.png";